import React, { useRef, useState } from 'react'
import { View, ScrollView, Linking, Image, Platform } from 'react-native'
import { StackNavigationProp } from '@react-navigation/stack'
import tw from 'tailwind-rn'
import { useSelector } from 'react-redux'
import { RootStackParamList } from '../../navigators/AppNavigator'

import styles from './styles'
import { Markdown } from '../../components/Content'
import { HGView, HGFlatList, HGButton } from '../../components/HGUI'
import CrossPlatformImage from '../../components/CrossPlatformImage'
import { getAssetUrl } from '../../lib/utils'
import { user } from '../../store/reducers/user'

const check = require('../../../assets/img/other/check.png')

const copy0 = `## Einschätzung der Eltern
- **Kooperativ** ("Bereitschaft"), adäquate Reaktionen auf Angebot und Sorge, Pünktlichkeit
- **Kompetenz** ("Fähigkeit"), familiäre Belastungsfaktoren, Gesundheitsstatus, Sprachverständnis`
const copy1 = `## Fallberatung

Anonyme Fallberatungen durch Fachärztinnen für Kinder- und Jugendmedizin und § 8a SGB VIII-Beratung durch eine insoweit erfahrene Fachkraft aus dem Bereich der Gesundheitshilfe.

Kinderschutzgruppe der nächstgelegenen Kinderklinik
Liste der insoweit erfahrenen Fachkräfte der Region: Jugendamt`
const copy2 = `Begleiten Sie den weiteren Fortgang und bestellen Sie die Patienten kurzfristig wieder ein, um die Risikoeinschätzung zu aktualisieren.

Vergessen Sie nicht jeden Schritt zu dokumentieren. Den Dokumentationsbogen können Sie hier laden:
`

type Props = {
  navigation: StackNavigationProp<RootStackParamList>
}

const SuspicionCheckerNeedForAdviceChildrenScreen = (
  props: Props
): React.ReactElement => {
  const { navigation } = props
  const [currentStage, setCurrentStage] = useState<string>('0')
  const globals = useSelector((state) => state.globals)
  const scrollView = useRef(null)

  const enterStage = (stage: string) => {
    setCurrentStage(stage)
    scrollView.current.scrollTo({ y: 0, animated: true })
  }

  return (
    <HGView>
      <ScrollView ref={scrollView}>
        <View style={tw('pt-6 px-3')}>
          {/* 0 */}
          {currentStage === '0' && (
            <View>
              <View style={tw('mb-5')}>
                <Markdown>{copy0}</Markdown>
              </View>

              <View style={styles.bottomActionBox}>
                <HGButton
                  title="Nächster Schritt"
                  onPress={() => enterStage('1')}
                />
              </View>
            </View>
          )}

          {/* 1 */}
          {currentStage === '1' && (
            <View>
              <View style={tw('b-5')}>
                <Markdown>{copy1}</Markdown>
              </View>

              <HGFlatList
                scrollEnabled={false}
                data={[
                  {
                    title: 'Meldestellen',
                    description: 'Jugendämter',
                    type: 'link',
                    key: 'chapter-advicecenter',
                    onPress: () =>
                      navigation.push('GenericResource', {
                        resourceId: '38',
                        slug: 'meldestellen',
                        ...(Platform.OS !== 'web' && { name: 'Meldestellen' }),
                      }),
                  },
                ]}
                keyExtractor={(item) => item.key}
              />

              <View style={styles.bottomActionBox}>
                <HGButton
                  title="Nächster Schritt"
                  onPress={() => enterStage('2')}
                />
              </View>
            </View>
          )}

          {/* 2 */}
          {currentStage === '2' && (
            <View>
              <View style={[styles.successBox, tw('mb-5')]}>
                <View style={tw('mr-3')}>
                  <CrossPlatformImage source={check} style={tw('w-5 h-5')} />
                </View>
                <View style={{ flex: 1, flexWrap: 'wrap' }}>
                  <Markdown>
                    ### Danke für Ihr Engagement im Kinderschutz!
                  </Markdown>
                </View>
              </View>

              <View style={tw('mb-5')}>
                <Markdown>{copy2}</Markdown>
              </View>

              <HGFlatList
                scrollEnabled={false}
                data={[
                  {
                    title: 'Dokumentationsbogen',
                    type: 'download',
                    key: 'chapter-download1',
                    onPress: () =>
                      Linking.openURL(getAssetUrl(globals?.documentationForm)),
                  },
                ]}
                keyExtractor={(item) => item.key}
              />

              <View style={styles.bottomActionBox}>
                <HGButton
                  title="Zurück zur Dokumentation"
                  onPress={() =>
                    navigation.reset({
                      routes: [{ name: 'Documentation' }],
                    })
                  }
                />
              </View>
            </View>
          )}
        </View>
      </ScrollView>
    </HGView>
  )
}

export default SuspicionCheckerNeedForAdviceChildrenScreen
